import routes from '@routes';
import { CacheProps, fetchApi } from '../../../fetch';

interface AddNewAddressProps extends CacheProps {
  latitude: string
  longitude: string
  address: string
  plate: string
  unit: string
  cityId: string
}

const addNewAddressApi = ({ address, longitude, latitude, plate, unit, cityId = '92', ...rest }: AddNewAddressProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.add.address'],
    payload: {
      latitude: latitude,
      longitude: longitude,
      address: address,
      plate: plate,
      unit: unit,
      city_id: cityId,
    },
    withToken: true,
    ...rest,
  });
};

export default addNewAddressApi;
